export const inclusionsToggleHint = (isOpen: boolean): string =>
    isOpen ? '(click to hide)' : '(click to view)';
